<template>
  <div class="wx-page-bk" v-if="showWxPageBK" >
    <img class="wx-page-bk-banner" src="@/assets/AiFavorableComments/AiFavorableCommentsBK.jpg" alt="">
    <!--      <img class="wx-page-bk-close" @click="showWxPageBK = false" src="@/assets/payClose.png" alt="">-->
  </div>
</template>

<script>
import UAParser from 'ua-parser-js';

export default {
  data() {
    return {
      showWxPageBK: false
    }
  },
  mounted() {
    this.checkBrowser();


  },
  methods: {
    checkBrowser() {
      const ua = navigator.userAgent.toLowerCase();
      const parser = new UAParser();
      const result = parser.getResult();
      // 内置浏览器识别
      const isAlipay = ua.includes("alipayclient");             // 支付宝 App 内
      const isAlipayMiniProgram = ua.includes("miniprogram");   // 支付宝小程序 WebView
      const isWeChat = ua.includes("micromessenger");
      const isQQ = ua.includes(" qq/");                         // 注意前面有空格避免误判
      const isDingTalk = ua.includes("dingtalk");

      // 系统外部浏览器（真正可 Deeplink 的）
      const isNormalBrowser = !(
          isAlipay ||
          isAlipayMiniProgram ||
          isWeChat ||
          isQQ ||
          isDingTalk
      );

      this.showWxPageBK = !isNormalBrowser
      // 保存系统是否允许跳转
      this.canDeepLink = isNormalBrowser;

      // 保存设备信息
      this.deviceInfo = {
        os: result.os.name,          // 'iOS', 'Android'
        brand: result.device.vendor,
        model: result.device.model
      };

      if (this.canDeepLink) {
        this.handleDeepLink();
      } else {
        console.log("当前为内置浏览器，禁止 Deeplink 跳转");
      }
    },

    handleDeepLink() {
      let params = this.getUrlParams(window.location.hash)
      const deeplink = params.scheme || '';
      const directJumpModels = [
        'iPhone','OpenHarmony'
      ];
      const device = this.deviceInfo || {};
      const model = device.model || "";

      const startJump = () => {
        window.location.href = deeplink;
      };

      // 高成功率机型 → 自动跳转
      if (directJumpModels.includes(model)) {
        setTimeout(startJump, 150);
        return;
      }
      // 其他机型 → 二次确认跳转
      this.$confirm('是否打开APP继续？', '提示', {
        confirmButtonText: '打开',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        startJump();
      }).catch(() => {
        console.log('用户取消跳转');
      });
    },
    getUrlParams(url) {
      const hashIndex = url.indexOf('#');
      if (hashIndex === -1) return {};

      const hash = url.slice(hashIndex + 1); // 去掉 #
      const queryIndex = hash.indexOf('?');
      if (queryIndex === -1) return {};

      const queryString = hash.slice(queryIndex + 1); // ? 后面的部分

      // 使用 URLSearchParams，保证 scheme 内的 ? 和 = 不被破坏
      const searchParams = new URLSearchParams(queryString);
      const params = {};
      for (const [key, value] of searchParams.entries()) {
        params[key] = value;
      }

      return params;
    },
  }
}

</script>

<style scoped>
.wx-page-bk {
  position: fixed;
  height: 100vh;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
}

.wx-page-bk-banner {
  width: 100%;
  height: 100%;

}
</style>
